module.exports = __webpack_public_path__ + "static/media/cycle.9ec10154.png";